import axios from 'axios';
import server from "../services/Connection/backEndLink";

export async function fetchSpecialCustomer(companyId, customerNo) {
    const url = server.url
    const payload = {
        data: {
            companyId: Number(companyId),
            customerNo
        }
    };
    const query = "/customer/discount";
    try {
        const response = await axios.post(`${url}${query}`, payload);
        return response.data.data.data[0] || null;
    } catch (error) {
        console.log(error);
        return null;
    }
}